<template>
    <compatibility-features
        v-if="activeBuild.cpu"
        :active-build="activeBuild"
        div-class="compatibility-list"
    />
</template>

<script>
import { mapState } from "vuex";
import CompatibilityFeatures from "./features";

export default {
    name: "CompatibilityIcons",
    components: {
        CompatibilityFeatures
    },
    computed: {
        ...mapState({
            activeBuild: state => state.Step4.activeBuild
        })
    }
}
</script>

<style lang="scss">
@import '~@s/_asset-mixers.scss';

.compatibility-list {
    position: relative;
    bottom: 60px;
    right: 50px;

    @media (min-width: 1300px) and (max-width: 1700px) {
        bottom: 80px;
    }

    @media (min-width: 767px) and (max-width: 1280px) {
        display: none;
    }

    &__features {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        @media (max-width: 768px) {
            padding-left: 10px;
        }
    }

    &__feature {
        width: 95px;
        text-align: center;
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;

        @media (min-width: 1300px) and (max-width: 1700px) {
            margin-bottom: 15px;
        }

        @media (min-width: 991px) and (max-width: 1200px) {
            width: 75px;
        }
        &.not-active {
            opacity: 0.2;
        }
        &__name {
            color: $white;
            font-size: 12px;
        }
        &__icon {
            height: 25px;
            display: flex;
            justify-content: center;
            img {
                max-width: 25px;
            }
        }
    }
}
</style>
